import { createGlobalStyle } from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
export default createGlobalStyle`
  html {
    /* stylelint-disable property-no-vendor-prefix, declaration-property-unit-whitelist */
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    font-size: 16px;
    line-height: 1;
    font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Oxygen-Sans,Ubuntu,Cantarell,'Helvetica Neue',sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    /* stylelint-enable */
  }
  body {
    margin: 0;
  }
  h1,
  h2,
  h3,
  h4,
  blockquote,
  figure,
  ol,
  ul {
    margin: 0;
    padding: 0;
  }
  main,
  li {
    display: block;
  }
  h1,
  h2,
  h3,
  h4 {
    font-size: inherit;
  }
  strong {
    font-weight: 700;
  }
  a,
  button {
    color: inherit;
    transition: .3s;
  }
  a {
    text-decoration: none;
  }
  button {
    overflow: visible;
    border: 0;
    font: inherit;
    -webkit-font-smoothing: inherit;
    letter-spacing: inherit;
    background: none;
    cursor: pointer;
  }
  ::-moz-focus-inner {
    padding: 0;
    border: 0;
  }
  :focus {
    outline: 0;
  }
  img {
    max-width: 100%;
    height: auto;
    border: 0;
  }

  body {
    min-height: 100%;
  }

  /* stylelint-disable selector-max-id */
  #root {
    display: flex;
    flex-direction: column;
    background-color: white;
    min-height: 100%;
    height: 100%;

    @supports (display: grid) {
      height: initial;
    }
  }
  /* stylelint-enable selector-max-id */
`

export const PRIMARY_COLOR = '#1DA1F2'
export const SECONDARY_COLOR = '#6057FF'

export const CONTENT_MAX_WIDTH = '105rem'
export const CONTENT_NEW_MAX_WIDTH = '90rem'
export const CONTENT_CUSTOM_MAX_WIDTH = '105.2rem'

export const COLOR_MIDNIGHT = colors.black1
export const COLOR_COAL = colors.black3
export const LIGHTER_BLACK_COLOR = colors.neutral1
export const COLOR_WHITE = colors.white

export const COLOR_DAWN = colors.dawn
export const COLOR_NEBULA = colors.nebula
export const COLOR_SARUMAN = colors.saruman
export const COLOR_RADAGAST = colors.radagast
export const COLOR_GANDALF = colors.gandalf
export const COLOR_DUST = colors.dust

export const COLOR_CHERNOBYL = colors.alert
export const COLOR_SHINING = colors.notification
export const COLOR_PICNIC = colors.confirmation

export const PLATFORM_BREAKPOINT = '101.875rem'

export const XLARGE_BREAKPOINT = '120rem'
export const LARGE_BREAKPOINT = '105rem'
export const MIDLARGE_BREAKPOINT = '90rem'
export const MIDLARGE_MAX_BREAKPOINT = '1439px'
export const MID_BREAKPOINT = '80rem'
export const SMALL_BREAKPOINT = '64rem'
export const XSMALL_BREAKPOINT = '48rem'
export const XXSMALL_BREAKPOINT = '36rem'
export const XXXSMALL_BREAKPOINT = '24rem'

export const placeholderColor = color => {
  return `
    ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: ${color};
      opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: ${color};
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
      color: ${color};
    }
  `
}



// WEBPACK FOOTER //
// ./src/style.tsx